import { axiosRequestData } from "../helpers/axios";

export const handlePostAxiosRequest = async(data:any) =>{
    let body: any = {
        flag: data
    }
    return await axiosRequestData("POST",'/wp-json/pg/v1/user/addflag',body)
}